import classNames from 'classnames';
import parseHtml from 'html-react-parser';
import { reduce } from 'lodash';
import { useRef } from 'react';

import * as registry from './registry';
import './style.m.less';

const registeredFeatures = registry.getFeatures();

const defaultProps = registeredFeatures.defaultProps;

const FEATURES = registeredFeatures.callbacks;

function RichText(passedProps) {
    'use memo';
    const ref = useRef();
    const props = { ...defaultProps, ...passedProps };
    const replace = getReplaceWithFeatures(props);

    const { value, className, style, onLinkClick, containerTag: Container = 'span' } = props;
    const htmlString = parseWithFeatures(value, props);
    return (
        <Container
            ref={ref}
            className={classNames(className, 'rich-text-view')}
            style={style}
            onClick={event => {
                const link = event.target.closest('a[href]');
                if (!onLinkClick || !link) {
                    return;
                }

                onLinkClick?.(link.getAttribute('href'));
            }}
        >
            {htmlString && parseHtml(htmlString, { replace })}
        </Container>
    );
}

export default RichText;

const IDENTITY = t => t;

export function parseWithFeatures(content, features) {
    if (!content) {
        return content;
    }

    return reduce(
        FEATURES,
        (mem, feature, name) => {
            const args = features[name];
            const fn = feature.onParse || IDENTITY;
            return args ? fn(mem, args) : mem;
        },
        content
    );
}

function getReplaceWithFeatures(features) {
    const onMountFns = Object.entries(FEATURES)
        .map(([name, feature]) => {
            const args = features[name];
            if (!feature.onMount || !args) {
                return;
            }

            return feature.onMount;
        })
        .filter(Boolean);
    return el => onMountFns.map(fn => fn(el)).find(Boolean);
}
